import script from "./ItemBill.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemBill.vue?vue&type=script&setup=true&lang=ts"

import "./ItemBill.vue?vue&type=style&index=0&id=07d2ed9d&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d2ed9d"]])

export default __exports__